import React__default from "react";
import { useListItem } from "@floating-ui/react";
import clsx from "clsx";
import { CarouselContext } from "./carousel-context.mjs";
const CarouselItem = (props) => {
  const { children, className } = props;
  const { ref, index } = useListItem();
  const { scrollToSlide, isSlideVisible } = React__default.useContext(CarouselContext);
  const isMouseFocus = React__default.useRef(false);
  const handleMouseDown = React__default.useCallback(() => {
    isMouseFocus.current = true;
  }, []);
  const handleMouseUp = React__default.useCallback(() => {
    isMouseFocus.current = false;
  }, []);
  const handleFocus = React__default.useCallback(() => {
    if (!isMouseFocus.current && !isSlideVisible(index)) {
      scrollToSlide(index);
    }
  }, [scrollToSlide, isSlideVisible, index]);
  return /* @__PURE__ */ React__default.createElement("div", { className: clsx("carousel__item", className), ref, onFocus: handleFocus, onMouseDown: handleMouseDown, onMouseUp: handleMouseUp }, children);
};
export {
  CarouselItem
};
